import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import { useFormik } from "formik";
import { TasksFormik, resType, task, taskData } from "../../../../../Types";
import axiosClientInterceptors from "../../../../ApiConfig/axiosClientInterceptor";
import { AxiosResponse } from "axios";
import { Toaster } from "../../../../Tools/Toaster";
import SmallLoader from "../../../../Tools/SmallLoader";
import Loader from "../../../../Tools/Loader";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteIcon from "../../../Assets/svg/deletelogo.svg";
import { validateActivityStatus } from "../../../../Tools/Validation";

const TaskType = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [addLoader, setAddLoader] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [task, setTask] = useState<task[]>([]);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDel, setOpenDel] = useState<boolean>(false);
  const [delLoader, setDelLoader] = useState<boolean>(false);
  const [taskID, setTaskID] = useState<string>("");
  const [editLoader, setEditLoader] = useState<boolean>(false);
  const [taskData, setTaskData] = useState<taskData>({
    section_name: "",
    _id: "",
  });

  const addTaskFormik = useFormik<TasksFormik>({
    initialValues: {
      projectStatus: "",
    },
    validationSchema: validateActivityStatus,
    onSubmit: (val) => {
      setAddLoader(true);
      axiosClientInterceptors
        .post(`/config/general`, {
          section_heading: "Task Type",
          section_name: val.projectStatus,
        })
        .then((res: AxiosResponse) => {
          const data: resType = res.data;
          if (data?.success) {
            setOpen(false);
            addTaskFormik.resetForm({});
            Toaster("success", data?.message);
            setAddLoader(false);
            setOpen(false);
            getTaskType();
          } else {
            Toaster("error", data?.message);
            setAddLoader(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setAddLoader(false);
        });
    },
  });

  const getTaskType = () => {
    setLoader(true);
    axiosClientInterceptors
      .get(`/config/general/Task Type`)
      .then((res: AxiosResponse) => {
        setTask(res.data?.result);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const editTaskFormik = useFormik<TasksFormik>({
    enableReinitialize: true,
    initialValues: {
      projectStatus: taskData?.section_name,
    },
    validationSchema: validateActivityStatus,
    onSubmit: (val) => {
      setEditLoader(true);
      axiosClientInterceptors
        .put(`/config/general/${taskData._id}`, {
          section_name: val.projectStatus,
        })
        .then((res: AxiosResponse) => {
          const data: resType = res.data;
          if (data?.success) {
            getTaskType();
            setOpenEdit(false);
            Toaster("success", data?.message);
            setEditLoader(false);
            editTaskFormik.resetForm({});
          } else {
            Toaster("error", data?.message);
            setEditLoader(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setEditLoader(false);
        });
    },
  });

  const deleteSection = () => {
    setDelLoader(true);
    axiosClientInterceptors
      .delete(`/config/general/${taskID}`)
      .then((res: AxiosResponse) => {
        const data: resType = res.data;
        if (data.success) {
          getTaskType();
          setOpenDel(false);
          Toaster("success", data?.message);
          setDelLoader(false);
        } else {
          Toaster("error", data?.message);
          setDelLoader(false);
        }
      })
      .catch((err: AxiosResponse) => {
        console.log(err);
        setDelLoader(false);
      });
  };

  useEffect(() => {
    getTaskType();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center h-[68px] p-6">
        <p className="project_Heading">Task Type</p>
        <button
          className="addstatus_btn w-[150px]"
          onClick={() => {
            setOpen(true);
          }}
        >
          {" "}
          <AddIcon sx={{ fontSize: "18px", marginBottom: "2px" }} /> Add Task
          Type
        </button>
      </div>

      {loader ? (
        <Loader customHeight={"30vh"} />
      ) : (
        <>
          {task?.map((item, i) => (
            <>
              <div
                className="flex justify-between items-center p-6 h-[55px] border-t-[2px] border-t-[#F5F8FA]"
                key={i}
              >
                <p className="content_title">{item?.section_name}</p>
                <div className="flex gap-5">
                  <button
                    className="edit_stuts"
                    onClick={() => {
                      setTaskData(item);
                      setOpenEdit(true);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete_status"
                    onClick={() => {
                      setTaskID(item?._id);
                      setOpenDel(true);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </>
          ))}
        </>
      )}

      {/* Add Task type pop starts */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          addTaskFormik.resetForm({});
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "386px",
              minHeight: "230px",
            },
          },
        }}
      >
        <div className="p-5">
          <div className="flex justify-between">
            <p className="font-[Gm] font-semibold text-[18px] text-[#000000]">
              Add New Task
            </p>
            <CloseRoundedIcon
              className="cursor-pointer"
              onClick={() => {
                setOpen(false);
                addTaskFormik.resetForm({});
              }}
            />
          </div>
          <form onSubmit={addTaskFormik.handleSubmit}>
            <div className="mt-4">
              <div>
                <label
                  htmlFor=""
                  className="font-[Gm] font-medium text-[13px] text-[#221E1F]"
                >
                  Task Name
                </label>
                <input
                  name="projectStatus"
                  type="text"
                  placeholder="Enter Task Name"
                  className="add_input mt-3 w-full"
                  onChange={addTaskFormik.handleChange}
                />
                {addTaskFormik.touched.projectStatus &&
                  addTaskFormik.errors.projectStatus && (
                    <p className="required_message">
                      {addTaskFormik.errors.projectStatus}
                    </p>
                  )}
              </div>
              <button
                disabled={addLoader}
                type="submit"
                className="input_btn mt-4 w-full"
              >
                {addLoader ? <SmallLoader color="" /> : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Dialog>
      {/* Add task type pop ends */}

      {/* Edit Task type pop starts */}
      <Dialog
        open={openEdit}
        onClose={() => {
          setOpenEdit(false);
          editTaskFormik.resetForm({});
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "386px",
              minHeight: "230px",
            },
          },
        }}
      >
        <div className="p-5">
          <div className="flex justify-between">
            <p className="font-[Gm] font-semibold text-[18px] text-[#000000]">
              Edit Task Type
            </p>
            <CloseRoundedIcon
              className="cursor-pointer"
              onClick={() => {
                setOpenEdit(false);
                editTaskFormik.resetForm({});
              }}
            />
          </div>
          <form onSubmit={editTaskFormik.handleSubmit}>
            <div className="mt-4">
              <div>
                <label
                  htmlFor=""
                  className="font-[Gm] font-medium text-[13px] text-[#221E1F]"
                >
                  Meeting Name
                </label>
                <input
                  name="projectStatus"
                  type="text"
                  placeholder="Enter Meeting Name"
                  className="add_input mt-3 w-full"
                  defaultValue={taskData.section_name}
                  onChange={editTaskFormik.handleChange}
                />
                {editTaskFormik.touched.projectStatus &&
                  editTaskFormik.errors.projectStatus && (
                    <p className="required_message">
                      {editTaskFormik.errors.projectStatus}
                    </p>
                  )}
              </div>
              <button
                disabled={editLoader}
                type="submit"
                className="input_btn mt-4 w-full"
              >
                {editLoader ? <SmallLoader color="" /> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Dialog>
      {/* Edit task type pop ends */}

      {/* delete pop starts */}
      <Dialog
        open={openDel}
        onClose={() => {
          setOpenDel(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "404px",
              height: "265px",
            },
          },
        }}
      >
        <div className="p-5">
          <div className="flex justify-center items-center">
            <img
              style={{
                width: "80px",
              }}
              src={DeleteIcon}
              alt=""
            />
          </div>
          <div className="deleteText mt-6">
            Are you sure want to Delete this Task Type?
          </div>
          <div className="flex justify-between items-center mt-9">
            <button
              className="cancelDelUser"
              onClick={() => {
                setOpenDel(false);
              }}
            >
              Cancel
            </button>
            <button
              className="delUser"
              onClick={() => {
                deleteSection();
              }}
            >
              {delLoader ? <SmallLoader color="" /> : "Delete"}
            </button>
          </div>
        </div>
      </Dialog>
      {/* delete pop ends */}
    </div>
  );
};

export default TaskType;
